import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Checkbox,
  Container,
  FormControlLabel,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import imgAwsAhnlabCloudLogo from 'assets/aws-ahnlab-cloud-logo.svg';
import smartnurseLogoStandard from 'assets/login_logo.png';
import Form from 'components/Form';
import theme from 'styles/theme';
import ConfirmButton from './components/ConfirmButton';
import PWConfirmButton from './components/PWConfirmButton';

interface Props {
  errors: { [x: string]: any };
  register: UseFormRegister<FieldValues>;
  onSignUp: () => void;
}

function SignInForm({ errors, register, onSignUp }: Props) {
  const { palette } = useTheme();

  return (
    <Box>
      <Container maxWidth="sm" sx={{ mt: 10, mb: 6 }}>
        <Card
          elevation={1}
          sx={{ borderTop: `solid 8px ${palette.primary.dark}` }}
        >
          <CardMedia
            height={120}
            component="img"
            image={smartnurseLogoStandard}
            sx={{ objectFit: 'contain', mt: 5, mb: 5 }}
          />
          <CardContent
            sx={{ width: '100%', textAlign: 'center', padding: '0 0 32px 0' }}
          >
            <Typography>현실감 있는 환자데이터 제공으로</Typography>
            <Typography sx={{ color: `${theme.palette.primary.dark}` }}>
              실제 병원 현장을 경험하게 됩니다!
            </Typography>
            <Box
              sx={{
                display: 'inline-flex',
                mt: 2,
                px: 2,
                py: 0.75,
                borderRadius: '999px',
                bgcolor: '#F2F2F2',
                maxWidth: '90%',
              }}
            >
              <Typography
                sx={{
                  fontSize: 13,
                  color: '#6B6B6B',
                  fontWeight: 500,
                  lineHeight: 1.4,
                }}
              >
                2.0 버전 현재 신규 개발 중
              </Typography>
            </Box>
          </CardContent>
          <CardContent sx={{ ml: 5, mr: 5 }}>
            <TextField
              fullWidth
              label="이메일"
              type="email"
              variant="outlined"
              sx={{ mb: 2.5 }}
              error={Boolean(errors.userEmail)}
              helperText={errors.userEmail?.message}
              {...register('userEmail', {
                required: '이메일을 입력해주세요.',
              })}
            />
            <Form.Password
              fullWidth
              label="비밀번호"
              sx={{ mb: 0.25 }}
              error={Boolean(errors.userPassword)}
              helperText={errors.userPassword?.message}
              {...register('userPassword', {
                required: '비밀번호를 입력해주세요.',
              })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  {...register('saveEmail')}
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
              label="이메일 저장"
            />
          </CardContent>
          <CardActions sx={{ ml: 5, mr: 5, pb: 5 }}>
            <Box flex={1} textAlign="center">
              <Button
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                sx={{ mb: 2.5 }}
              >
                로그인
              </Button>
              <Button
                fullWidth
                variant="outlined"
                size="large"
                sx={{
                  mb: 2.5,
                  backgroundColor: 'white',
                  color: '#2D73DC',
                  border: '1px solid #2D73DC',
                }}
                onClick={onSignUp}
              >
                회원가입
              </Button>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  justifyContent: 'center',
                }}
              >
                <ConfirmButton title="아이디 찾기" color={'black'} />
                <Typography sx={{ lineHeight: '28px', fontSize: '12px' }}>
                  {' | '}
                </Typography>
                <PWConfirmButton title="비밀번호 찾기" color={'black'} />
              </Box>
              <Button
                fullWidth
                size="large"
                variant="outlined"
                sx={{
                  mt: 2,
                  mb: 2.5,
                  backgroundColor: 'white',
                  color: '#2D73DC',
                  border: '1px solid #2D73DC',
                }}
                onClick={() => window.open('https://www.smartnurse.co.kr/')}
              >
                스마트널스 홈페이지 바로가기
              </Button>

              <Typography sx={{ fontSize: '0.8125rem' }}>
                문의: nurse@smartnurse.co.kr
              </Typography>
            </Box>
          </CardActions>

          <CardMedia
            height={28}
            component="img"
            image={imgAwsAhnlabCloudLogo}
            sx={{ objectFit: 'contain', mb: 1 }}
          />
          <Typography fontSize={10} align="center" sx={{ mb: 2 }}>
            Copyright © 2022-2026 DKMediInfo. All rights reserved.
          </Typography>
        </Card>
      </Container>
    </Box>
  );
}

export default SignInForm;
